import { tr, fromNow } from "../../i18n";

export function textify_path(path, t){
    t = t || tr;
    if(!path)return '?';
    if(path==='/') return t('chat.home');
    if(path.match(/^\/Q\d+$/)) return path.replace(/^../, t('chat.quotation_prefix'));
    return path;
}


export function format_datetime(datetime){
    try{
        return fromNow(datetime);
    }catch(e){}
    return datetime;
}


export function decompress_array_packet(packet){
    return packet.data.map(a=>({
        id: a[0],
        userName: packet.users[a[2]] || '?',
        time: format_datetime(a[1]),
        me: a[2]<1 ||a[2]==9,
        msg: a[3],
        read: a[4]==1
    }));
}

